module.exports = __webpack_public_path__ + "img/vue-anime-quoter.925098ac.png";